export default __webpack_public_path__ + "static/media/(97).9317110c.jpg";